import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f99867b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content-footer" }
const _hoisted_3 = { class: "flex flex-col gap-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-secondary-clear mb-1" }, "r2business.app ", -1))
const _hoisted_5 = { class: "footer-links-group" }
const _hoisted_6 = { class: "footer-links-container" }
const _hoisted_7 = { class: "footer-tilte" }
const _hoisted_8 = { class: "footer-link" }
const _hoisted_9 = { class: "footer-link" }
const _hoisted_10 = { class: "footer-links-container" }
const _hoisted_11 = { class: "footer-tilte" }
const _hoisted_12 = { class: "footer-link" }
const _hoisted_13 = { class: "footer-links-container" }
const _hoisted_14 = { class: "footer-tilte" }
const _hoisted_15 = { class: "footer-link" }
const _hoisted_16 = { class: "footer-link" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_18 = { class: "copyrigth-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode($setup["AppInputSelect"], {
            class: "text-white",
            "label-color": "secondary-basic",
            "input-color": "secondary-dark",
            inputSize: "lite",
            enableUnselect: false,
            showSelectCircle: false,
            modelValue: $setup.selection,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selection) = $event)),
            "list-options": $setup.LANGUAGES
          }, null, 8, ["modelValue", "list-options"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('Footer.platform')), 1),
            _createVNode(_component_router_link, { to: {name:'Home'} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('Footer.why_r2business')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: '/#pricing' }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('Footer.pricing')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('Footer.features')), 1),
            _createVNode(_component_router_link, { to: '/#features' }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('Footer.resume')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('Footer.legal')), 1),
            _createVNode(_component_router_link, { to: {name:'CookiesPolicy'} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('Footer.cookiesPolicy')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: {name:'TermsAndConditions'} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('Footer.termsAndConditions')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('Footer.copyR')), 1)
    ])
  ]))
}